import { jsxs as d, jsx as p } from "react/jsx-runtime";
import { useMemo as f } from "react";
import { Button as y, CircularProgress as x } from "@mui/material";
import { makeStyles as b } from "tss-react/mui";
import h from "./Button.style.js";
const B = b()(h), $ = ({
  variation: t = "primary",
  size: e = "medium",
  className: o = "",
  isLoading: s,
  disabled: r,
  dataTestid: n = "Lumi-button",
  children: a,
  onClick: i,
  ...u
}) => {
  const { classes: m } = B(), l = `${m.btn} ${o}`, c = f(() => {
    switch (t) {
      case "ghost":
        return "outlined";
      case "text":
        return "text";
      default:
        return "contained";
    }
  }, [t]);
  return /* @__PURE__ */ d(
    y,
    {
      variant: c,
      className: l,
      disabled: s || r,
      size: e,
      "data-testid": n,
      onClick: i,
      ...u,
      children: [
        a,
        s && /* @__PURE__ */ p(
          x,
          {
            size: 30,
            color: "secondary",
            style: { position: "absolute", right: 20 }
          }
        )
      ]
    }
  );
}, w = $;
export {
  $ as Button,
  w as default
};
